module.exports = __webpack_public_path__ + "img/comment.05f871f5.svg";